export default __webpack_public_path__ + "static/media/wake-me-up.f452294c.jpg";